<div class="hero-video">
  <video [class]="videoBottomCurve ? 'videoBottomCurve' : ''" [ngClass]="{ 'min-width-class' : isMinWidth ,  'max-width-class' : !isMinWidth }" #myHeroVideo 
      autoplay [muted]="'muted'" loop playsinline id="heroVideo">
    <source [attr.src]="videoUrl" type="video/mp4" />
  </video>
</div>
